import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './styles/index.css';

import reportWebVitals from './reportWebVitals';
import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline';
import { BrowserRouter as Router } from 'react-router-dom';

ReactDOM.render(
	<React.StrictMode>
		<Router>
			<ScopedCssBaseline>
				<App />
			</ScopedCssBaseline>
		</Router>
	</React.StrictMode>,
	document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
